<template>
  <div id="app" :class="{rtl: $i18n.locale === 'AR'}">
    <Head></Head>
    <router-view/>
    <Accept v-if="showAccept" @close="showAccept = false"></Accept>
    <Alert v-if="alertinfo.showis"></Alert>
    <Loading v-if="showLoading" />
  </div>
</template>

<script>
import Head from '@/components/common/head/index.vue'
import Accept from '@/components/common/accept.vue'
import Alert from '@/components/common/Alert.vue'
import Loading from '@/components/common/loading.vue'
import { mapGetters,mutations } from 'vuex'
export default {
  name: 'App',
    components:{Head,Accept,Alert,Loading},
    computed: {
      ...mapGetters([
        'accept',
        'alertinfo',
        'showLoading'
      ]),
    },
    data() {
      return {
        pcis:false,
        showAccept: false,
      }
    },
    created() {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
          this.pcis = false;
        }else{
          this.pcis = true;
        }
        this.showAccept = !this.accept

    },
}
</script>

<style>
    p,h4,div,body,html,input,img{
      margin: 0;
      padding: 0;
    }
    @font-face {
        font-family: "Regular";
        src: url("./font/Poppins-Regular.ttf");
        font-style: normal;
        font-weight: normal;
    }
    @font-face {
        font-family: "Light";
        src: url("./font/Poppins-Light.ttf");
        font-style: normal;
        font-weight: normal;
    }
    @font-face {
        font-family: "SemiBold";
        src: url("./font/Poppins-SemiBold.ttf");
        font-style: normal;
        font-weight: normal;
    }
    body,html{
      width: 100%;
      height: 100%;
    	background-color: #254167;
    	overflow-x: hidden;
      font-family: "Light";
    }
    body{
      -webkit-user-select: none; /* Chrome, Safari, Opera */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
      touch-action: manipulation;
    }
    @media (max-width: 1024px) {
      .hidden_m{
        display: none !important;
      }
    }
    @media (min-width: 1024px) {
      .hidden_pc{
        display: none !important;
      }
    }
    #app{
      padding-top:3.125rem;
      height: 100%;
      box-sizing: border-box;
    }

    #app.rtl{
      direction: rtl;
    }

    .title{
      font-size: 1.3rem;
      padding: 0 0.9375rem;
      line-height: 2.5rem;
      font-weight: 500;
      color: #FFFFFF;
      font-family: "SemiBold";
    }
    .mask{
      position: fixed;
      top: 0;
      left: 0;
      z-index: 101;
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      background-color:rgba(0,0,0,0.6) ;
    }
    .mask_main_content{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      max-width: 750px;
      width: 90%;
      box-sizing: border-box;
    }
   .load{
      width: 1.875rem;
      height: 1.875rem;
      display: block;
      background-color: #FFFFFF;
      border-radius: 1.875rem;
      padding: 0.25rem;
      margin: 1.875rem auto;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue